<template>
  <div>
    <SplitListView :show-bottom-sheet="showBottomSheet">
      <template v-slot:list>
        <v-row
          dense
          class="px-4 pt-2"
        >
          <v-col cols="6">
            <DateSelection
              dense
              hide-details
              outlined
              no-icon
              :full-width="false"
              :clearable="true"
              :label="$t('from')"
              :value="startTimeInMillis"
              @input="onStartTimeChange"
            />
          </v-col>
          <v-col cols="6">
            <DateSelection
              dense
              hide-details
              outlined
              no-icon
              :full-width="false"
              :clearable="true"
              :label="$t('to')"
              :value="endTimeInMillis"
              @input="onEndTimeChange"
            />
          </v-col>
        </v-row>
        <v-alert
          v-if="messagesCappedAtLimit"
          type="warning"
          text
          dense
          class="mx-4"
        >
          {{ $t('messagesResultsCappedHint') }}
        </v-alert>
        <ActionList
          ref="messagesList"
          :load-items-callback="getMessengerMessages"
          :empty-text="$t('noCombinationsFound')"
          :filters="filters"
          refreshable
        >
          <template v-slot:item="{ item }">
            <MessengerMessageListItem
              :message="item"
              @click="messageSelected"
            />
          </template>
        </ActionList>
      </template>
      <template v-slot:view>
        <MessengerMessageProfile
          v-if="selectedMessage !== null"
          :message="selectedMessage"
        />
      </template>
    </SplitListView>
  </div>
</template>

<script>
import ActionList from "@/components/common/list/ActionList"
import MessengerMessageListItem from "@/components/messages/MessengerMessageListItem"
import MessengerMessageProfile from "@/components/messages/MessengerMessageProfile"
import SplitListView from "@/components/layouts/SplitListView"
import DateSelection from "@/components/common/DateSelection"

const DEFAULT_RANGE_IN_MILLIS = 1000 * 60 * 60 * 24 * 20
const MESSAGES_RESULT_LIMIT = 350

export default {
  name: "Messages",
  components: {SplitListView, MessengerMessageProfile, MessengerMessageListItem, ActionList, DateSelection},
  data() {
		return {
			selectedMessage: null,
			startTimeInMillis: Date.now() - DEFAULT_RANGE_IN_MILLIS,
			endTimeInMillis: Date.now(),
			messagesCappedAtLimit: false,
			filters: [
				{
					key: 'state',
					label: this.$t('state'),
					type: 'select',
					value: null,
					items: ['delivered', 'pending'],
					operator: 'contains'
				},
				{
					key: 'namespace',
					label: this.$t('namespace'),
					type: 'select',
					value: null,
					items: ['email', 'printjob', 'sms'],
					operator: 'contains'
				},
				{
					key: 'destination',
					label: this.$t('sku'),
					type: 'text',
					value: null,
					operator: 'contains'
				},
				{
					key: 'uuid',
					label: this.$t('universalUniqueIdentifier'),
					type: 'text',
					value: null,
					operator: 'contains'
				}
			]
		}
  },
  computed: {
    showBottomSheet: {
      get() {
        return this.selectedMessage !== null
      },
      set(value) {
        this.selectedMessage = null
      }
    }
  },
  methods: {
    getMessengerMethodInstances() {
      this.$store.dispatch('getMessengerMethodInstances')
    },
    getMessengerMessages() {
      const startTimeInMillis = this.startTimeInMillis
      const endTimeInMillis = this.endTimeInMillis

      return this.$store.dispatch('getMessengerMessages', {startTimeInMillis, endTimeInMillis}).then(res => {
        this.messagesCappedAtLimit = Array.isArray(res) && res.length === MESSAGES_RESULT_LIMIT
        return res
      })
    },
    onStartTimeChange(value) {
      this.startTimeInMillis = value !== null ? value : Date.now() - DEFAULT_RANGE_IN_MILLIS
      if (this.startTimeInMillis > this.endTimeInMillis) {
        this.endTimeInMillis = this.startTimeInMillis
      }
      this.refreshMessages()
    },
    onEndTimeChange(value) {
      this.endTimeInMillis = value !== null ? value : Date.now()
      if (this.endTimeInMillis < this.startTimeInMillis) {
        this.startTimeInMillis = this.endTimeInMillis
      }
      this.refreshMessages()
    },
    refreshMessages() {
      if (this.$refs.messagesList) {
        this.$refs.messagesList.refreshItems()
      }
    },
    messageSelected(m) {
      this.selectedMessage = m
    }
  },
  mounted() {
    this.getMessengerMethodInstances()
  }
}
</script>

<style scoped>

</style>
